"use client";

import {ToastContainer, type ToastContainerProps} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {FadeTransition} from "../../constants/toaster"

export function DialogScopedToaster({
                                      containerId,
                                      position = "bottom-center",
                                      autoClose = 3000,
                                      newestOnTop = true,
                                      hideProgressBar = true,
                                      closeButton = false,
                                      closeOnClick = true,
                                      pauseOnHover = true,
                                      draggable = false,
                                      theme="dark",
                                      transition = FadeTransition,
                                      ...rest
                                    }: ToastContainerProps & {
  containerId: string
}) {
  return (
    <ToastContainer
      containerId={containerId}
      position={position}
      autoClose={autoClose}
      newestOnTop={newestOnTop}
      hideProgressBar={hideProgressBar}
      closeButton={closeButton}
      closeOnClick={closeOnClick}
      pauseOnHover={pauseOnHover}
      draggable={draggable}
      theme={theme}
      transition={transition}
      className="absolute! z-9999 pointer-events-none"
      toastClassName="w-[95%]! pointer-events-auto flex m-0 mx-auto! items-center gap-2 rounded-xl shadow-lg border-none transition-all duration-200"
      {...rest}
    />
  );
}